var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { Field } from 'react-redux-form';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate } from "../../I18N";
import { NestedMultiselect } from "../../ReactReduxForms";

class NestedFilter extends Component {
  render() {
    const { onChange, model, label, property, aggregations } = this.props;
    return /*#__PURE__*/(
      _jsx("ul", { className: "search__filter is-active" }, void 0, /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx("label", {}, void 0, label), /*#__PURE__*/
      _jsx("div", { className: "nested-strict" }, void 0, /*#__PURE__*/
      _jsx(Field, { model: `${model}.strict` }, void 0, /*#__PURE__*/
      _jsx("input", { id: `${model}strict`, type: "checkbox", onChange: onChange })), /*#__PURE__*/

      _jsx("label", { htmlFor: `${model}strict` }, void 0, /*#__PURE__*/
      _jsx("span", {}, void 0, "\xA0", /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Strict mode"))))), /*#__PURE__*/




      _jsx("li", { className: "wide" }, void 0, /*#__PURE__*/
      _jsx(NestedMultiselect, { aggregations: aggregations, property: property, onChange: onChange }))));



  }
}

NestedFilter.defaultProps = {
  onChange: () => {},
  label: '',
  aggregations: Immutable.Map()
};









export default NestedFilter;